const prefix = 'admin-corporations'

export const CorporationsQueryKeys = {
  Corporations: `${prefix}/corporations`,
  CurrentCorporation: `${prefix}/current-corporation`,
}
